var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE6\x9D\xA5\xE6\xBA\x90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6142 7.46017L7.57694 5.12999C7.0625 4.83311 6.64165 5.06223 6.64165 5.63934L6.64165 6.95082L1.09066 6.95082C0.488351 6.95082 -4.23229e-07 7.42059 -5.24535e-07 7.99999C-6.25843e-07 8.57941 0.488351 9.04917 1.09066 9.04917L6.64165 9.04917L6.64165 10.3606C6.64165 10.9378 7.0625 11.1669 7.57693 10.87L11.6142 8.53984C12.1286 8.24296 12.1286 7.75705 11.6142 7.46017Z",
    fill: "#61D4AD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 163",
    x: 13,
    y: 2,
    width: 2,
    height: 12,
    rx: 1,
    fill: "#61D4AD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/来源.d0a7440e16f7a14882dc394cd7b445d6.svg";
export { ForwardRef as ReactComponent };